import React, { Component } from "react";

const LoadingPage = () => {
  return (
    <div className="container-fluid full-height-nav-foot">
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active" />
      </div>
    </div>
  );
};

export default function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null
      };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({
        component: component
      });
    }

    render() {
      const C = this.state.component;

      return C ? <C {...this.props} /> : <LoadingPage />;
    }
  }

  return AsyncComponent;
}



// WEBPACK FOOTER //
// ./src/components/Routes/AsyncComponent.js